import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SpaceResponse } from '@/api/data-contracts';
import { floorLevels } from '@/features/spaces';
import { placementAreas, supportNames } from '@/shared/constants';
import { ImageResource } from '@/shared/lib/hooks/useResourceImage';

import ShoppingCartListItem from './ShoppingCartListItem';

const ShoppingCartSpaceItem: FC<{
  rowId: string;
  space: SpaceResponse & { cartPrice?: number };
}> = ({ rowId, space }) => {
  const { t } = useTranslation();

  const imageResource = useMemo<ImageResource | null>(() => {
    const objectId = space?.supportFiles?.[0]?.objectId;
    if (!objectId || !space?.id) return null;
    return { kind: 'space-document', spaceId: space.id, documentId: String(objectId) };
  }, [space?.id, space?.supportFiles]);

  const support = useMemo(
    () => supportNames.find((s) => s.value === space.support)?.label,
    [space.support],
  );

  return (
    <ShoppingCartListItem
      rowId={rowId}
      table="ADVERTISING_SPACES"
      imageResource={imageResource}
      title={support ?? space.support ?? ''}
      price={space.cartPrice ?? (space.price || space.pricing?.monthPricing)}
      floor={floorLevels.find((f) => f.value === space.floor)?.label ?? ''}
      exposureType={
        space.exposureType === 'INDOOR'
          ? t('Indoor')
          : space.exposureType === 'OUTDOOR'
            ? t('Outdoor')
            : ''
      }
      placementArea={placementAreas.find((pa) => pa.value === space.placementArea!)?.label}
      onClick={() => window.open(`/advertising-spaces/${space.id}`, '_blank')}
    />
  );
};

export default ShoppingCartSpaceItem;
